import React, { useState } from "react";
import { FileText, ExternalLink, Copy, CheckCircle, Zap } from "lucide-react";
import "./GFSDocs.css";

const GFSV1Docs = () => {
  const [copied, setCopied] = useState(false);

  const getDocsUrl = () => {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return "http://localhost:5001/api/extraction/gfs/v1/docs";
    }
    return `${window.location.protocol}//${window.location.hostname}/api/extraction/gfs/v1/docs`;
  };

  const getApiKeyFromStorage = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.api_key || "";
    } catch {
      return "";
    }
  };

  const copyApiKey = () => {
    const apiKey = getApiKeyFromStorage();
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="gfs-docs-page">
      {/* Header Banner */}
      <div className="gfs-docs-header v1">
        <div className="gfs-docs-header-content">
          <div className="gfs-docs-icon">
            <Zap size={32} />
          </div>
          <div>
            <h1>GFS V1 API Documentation</h1>
            <p>Textract OCR + Claude Extraction Pipeline</p>
          </div>
        </div>
        <a 
          href={getDocsUrl()} 
          target="_blank" 
          rel="noopener noreferrer"
          className="gfs-docs-external-btn"
        >
          <ExternalLink size={18} />
          Open in New Tab
        </a>
      </div>

      {/* Info Cards */}
      <div className="gfs-docs-info-grid">
        <div className="gfs-docs-info-card">
          <h3><FileText size={18} /> Pipeline Details</h3>
          <ul>
            <li><strong>OCR Engine:</strong> AWS Textract</li>
            <li><strong>Extraction Model:</strong> Claude (via Bedrock)</li>
            <li><strong>Form Type:</strong> Required parameter</li>
            <li><strong>Endpoint:</strong> POST /api/extraction/gfs/v1</li>
          </ul>
        </div>

        <div className="gfs-docs-info-card">
          <h3><FileText size={18} /> Supported Forms</h3>
          <ul>
            <li><strong>aof:</strong> Account Opening Form</li>
            <li><strong>redemption:</strong> Redemption Form (RP)</li>
            <li><strong>additional_purchase:</strong> Additional Purchase (IUTA/Additional Investment)</li>
            <li><strong>topup_manulife_prs:</strong> Manulife PRS Form</li>
            <li><strong>topup_maybank_booking:</strong> Maybank Booking Report</li>
            <li><strong>topup_phillip_mutual:</strong> Phillip Mutual Report</li>
            <li><strong>topup_ifast_orders:</strong> iFAST Cash Orders</li>
            <li><strong>topup_epf_kwsp:</strong> EPF KWSP 9N</li>
          </ul>
        </div>

        <div className="gfs-docs-info-card api-key-card">
          <h3>Your API Key</h3>
          <div className="gfs-docs-api-key-row">
            <code>{getApiKeyFromStorage() || "Not available - please log in"}</code>
            <button onClick={copyApiKey} disabled={!getApiKeyFromStorage()}>
              {copied ? <CheckCircle size={16} /> : <Copy size={16} />}
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </div>

      {/* Swagger Iframe */}
      <div className="gfs-docs-iframe-container">
        <iframe
          src={getDocsUrl()}
          title="GFS V1 Swagger Documentation"
          className="gfs-docs-iframe"
        />
      </div>
    </div>
  );
};

export default GFSV1Docs;
